<section class="login">
  <h1>View private projects</h1>
  <p class="lead">
    Sign in with Google or get a magic link by email. While you stay signed in, you can view hidden projects and open the detailed view to see deeper overviews.
  </p>

  @if (busy && completingEmailLink) {
    <p class="state">Completing sign-in…</p>
    <mat-spinner diameter="36" />
  } @else {
    <div class="actions">
      <button
        type="button"
        mat-flat-button
        color="primary"
        class="primary-action"
        (click)="signInWithGoogle()"
        [disabled]="busy">
        Log in with Google
      </button>
    </div>

    <p class="divider">or</p>

    <form class="email-form" [formGroup]="emailForm" (ngSubmit)="sendEmailLink()">
      <mat-form-field appearance="outline" class="full">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" autocomplete="email" />
      </mat-form-field>
      <button type="submit" mat-stroked-button class="secondary-action" [disabled]="busy">Send magic link</button>
    </form>
  }

  @if (errorMessage) {
    <p class="error" role="alert">{{ errorMessage }}</p>
  }
  @if (infoMessage) {
    <p class="info">{{ infoMessage }}</p>
  }
</section>
